"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = exports.IntermediatePrice = exports.TotalPrice = exports.TotalText = exports.ServiceTitle = exports.ServiceTilteRow = exports.Row = exports.Rectangle = exports.Price = exports.Info = exports.BagsPrice = exports.ServiceContainer = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display       : flex;\n  flex-direction: column;\n"])));

exports.Container = Container;
Container.displayName = 'Container';

var ServiceContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display       : flex;\n  flex-direction: column;\n"])));

exports.ServiceContainer = ServiceContainer;
ServiceContainer.displayName = 'ServiceContainer';

var BagsPrice = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display       : flex;\n  flex-direction: column;\n  border-radius: 4px;\n  background-color: ", "  \n"])), _palette.palette.darkWhite);

exports.BagsPrice = BagsPrice;
BagsPrice.displayName = 'BagsPrice';

var Info = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display  : flex;\n  padding: ", "px ", "px ", "px ", "px;\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  color: ", ";\n"])), _widths.widths.base, _widths.widths.base * 4, _widths.widths.base, _widths.widths.base, _palette.palette.bobBlack);

exports.Info = Info;
Info.displayName = 'Info';

var Price = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size : 14px;\n  text-align: right;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n"])));

exports.Price = Price;
Price.displayName = 'Price';

var Rectangle = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  align-self      : center;\n  background-color: ", ";\n  height          : 2px;\n  width           : ", "px;\n"])), function (props) {
  return props.color || _palette.palette.success;
}, _widths.widths.base * 3);

exports.Rectangle = Rectangle;

var Row = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;  \n  & div {\n    flex: 1;\n  }\n\n  & div:first-child {\n    margin-right: ", "px;\n  }\n"])), _widths.widths.base);

exports.Row = Row;
Row.displayName = 'Row';

var ServiceTilteRow = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direcction: row;  \n  padding: ", "px;\n  width: calc(100% - 50px);\n"])), _widths.widths.base);

exports.ServiceTilteRow = ServiceTilteRow;

var ServiceTitle = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex: 1 1 90%;\n  font-size: 14px;\n  font-weight: ", ";\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  color: ", ";\n"])), _widths.font.semi, _palette.palette.bobBlack);

exports.ServiceTitle = ServiceTitle;
ServiceTitle.displayName = 'ServiceTitle';

var TotalText = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size  : 14px;\n  font-weight: ", ";\n  margin-top : ", "px;\n  color: ", ";\n  text-align : left;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n"])), _widths.font.semi, _widths.widths.base * 2, _palette.palette.bobBlack);

exports.TotalText = TotalText;
TotalText.displayName = 'TotalText';

var TotalPrice = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size  : 24px;\n  font-weight: ", ";\n  margin-top : ", "px;\n  color: ", ";\n  text-align : right;  \n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.08;\n  letter-spacing: normal;\n"])), _widths.font.semi, _widths.widths.base * 2 - 10, _palette.palette.bobBlack);

exports.TotalPrice = TotalPrice;
TotalPrice.displayName = 'TotalPrice';
var IntermediatePrice = (0, _styledComponents["default"])(Price)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: ", ";  \n"])), _widths.font.semi);
exports.IntermediatePrice = IntermediatePrice;
IntermediatePrice.displayName = 'IntermediatePrice';

var Separator = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  height: 1px;\n  border-top: 1px solid ", ";\n  margin-left: ", "px;\n  margin-right: ", "px;\n"])), _palette.palette.darkWhite, _widths.widths.base, _widths.widths.base * 3);

exports.Separator = Separator;
Separator.displayName = 'Separator';